/**
 * 报名审核列表
 * @description 报名审核列表
 * @author mll
 * @date 2021-01-07
 */

import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '@/tool';
import './index.less'
import { reduxTemplateCofig, templateConfig } from './config'
import {string} from "prop-types";
const { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport } = component_tool;

const _getValue = (type, key) => {
    const values = {
        status: {
            1: '待审核',
            2: '已通过',
            3: '未通过',
            4: '审核中'
        },
        jobState: {
            0: '离职',
            1: '在职'
        }

    };
    return values[type][key]
};

class applyVerifyList extends WizContainer {

    componentName = 'applyVerifyList';

    constructor(props) {
        super(props)
        let {history} = props
        let pathname = '/workflow/apply'
        if (history.location && history.location.pathname && history.location.pathname.startsWith('/perm/applyPerm')) {
            pathname = '/perm/applyPerm'
        }
        let applyInfo = {}
        if (history.location.record) {
            applyInfo = history.location.record
          }
        this.pathname = pathname
        this.state = {
            applyInfo:applyInfo
        }
    }

    _handleCMD(nextProps, nextState, key) {
        let o = nextProps[key]
        if (o['success']) {
            wizNotice.success(o['msg'])
            return true;
        } else {
            wizNotice.error(o['msg'])
            return false;
        }
    }

    _handleAuditCMD(nextProps, nextState, key) {
      let o = nextProps[key]
      let data = o['data'];
      this.changeModal(false, true, true)
        if (o['success']) {
          if (data && data!=null && data!='' && data!=undefined){
          }else {
            data = o['msg'];
          }
          let str = data && data.replace(/<br\/>/g, "\n");
            wizNotice.success({
              key: 'default',
              message: '成功',
              description: (
                <div>
                  <p style={{ whiteSpace: "pre-line" }}>{str}</p>
                </div>
              ),
            })
            return true;
        } else {
          if (data && data instanceof string ){
          }else {
            data = o['msg'];
          }
          let str = data && data.replace(/<br\/>/g, "\n");
          wizNotice.error({
            key: 'default',
            message: '失败',
            description: (
              <div>
                <p style={{ whiteSpace: "pre-line" }}>{str}</p>
              </div>
            ),
          });
          return false;
        }
    }
    /**
     * 查看
     */
    look = (e,applyId) => {
        this.jumpPage('push', this.pathname+'Verify/verify', { rows: [{ ...e, mode: e && e['status'] === 1 ? 'audio' : e['status'] === 4 ? 'endAudio' : 'look' }],applyId:applyId })
    }

    /**
     * 导出
     * @param {*} nextProps
     * @param {*} nextState
     * @param {*} key
     */
    _handleFile(nextProps, nextState, key) {
        let o = nextProps[key]
        let columnDefs = [
            {
                headerName: '报名申请',
                width: 30,
                field: 'rowIndex',
                hidden: true,
                suppressMovable: true,
                cellStyle: {
                    textAlign: 'center',
                    padding: '5px 0',
                    color: '#595959',
                    backgroundColor: '#f0f0f0',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: '500',
                    boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
                },
            },
            {
                headerName: '账号',
                field: 'userName',
                width: 20,
                cellStyle: {
                    textAlign: 'center',
                },
                style: {
                    alignment: { vertical: 'bottom', horizontal: 'left' },
                },
            },
            {
                headerName: '姓名',
                field: 'fullName',
                width: 20,
                cellStyle: {
                    textAlign: 'center',
                },
                style: {
                    alignment: { vertical: 'bottom', horizontal: 'left' },
                },
            },
            // {
            //     headerName: '证件号码',
            //     field: 'idCard',
            //     width: 20,
            //     cellStyle: {
            //         textAlign: 'center',
            //     },
            //     style: {
            //         alignment: { vertical: 'bottom', horizontal: 'left' },
            //     },
            // },
            {
                headerName: '邮箱',
                field: 'email',
                width: 20,
                cellStyle: {
                    textAlign: 'center',
                },
                style: {
                    alignment: { vertical: 'bottom', horizontal: 'left' },
                },
            },
            {
                headerName: '手机号',
                field: 'mobile',
                width: 20,
                cellStyle: {
                    textAlign: 'center',
                },
                style: {
                    alignment: { vertical: 'bottom', horizontal: 'left' },
                },
            },
            {
                headerName: '组织名称',
                field: 'orgName',
                width: 20,
                cellStyle: {
                    textAlign: 'center',
                },
                style: {
                    alignment: { vertical: 'bottom', horizontal: 'left' },
                },
            },
            {
                headerName: '组织编码',
                field: 'orgCode',
                width: 20,
                cellStyle: {
                    textAlign: 'center',
                },
                style: {
                    alignment: { vertical: 'bottom', horizontal: 'left' },
                },
            },
            {
                headerName: '区域',
                field: 'areaName',
                width: 20,
                cellStyle: {
                    textAlign: 'center',
                },
                style: {
                    alignment: { vertical: 'bottom', horizontal: 'left' },
                },
            },
            {
                headerName: '岗位',
                field: 'positionName',
                width: 15,
                cellStyle: {
                    textAlign: 'center',
                },
                style: {
                    alignment: { vertical: 'bottom', horizontal: 'left' },
                },
            },
            {
                headerName: '任职状态',
                field: 'jobState',
                width: 20,
                cellStyle: {
                    textAlign: 'center',
                },
                style: {
                    alignment: { vertical: 'bottom', horizontal: 'left' },
                },
            },
            {
                headerName: '报名名称',
                field: 'applyName',
                width: 25,
                cellStyle: {
                    textAlign: 'center',
                },
                style: {
                    alignment: { vertical: 'bottom', horizontal: 'left' },
                },
            },
            {
                headerName: '计划安排名称',
                field: 'planName',
                width: 25,
                cellStyle: {
                    textAlign: 'center',
                },
                style: {
                    alignment: { vertical: 'bottom', horizontal: 'left' },
                },
            },
            {
                headerName: '审核状态',
                field: 'status',
                width: 15,
                cellStyle: {
                    textAlign: 'center',
                },
                style: {
                    alignment: { vertical: 'bottom', horizontal: 'left' },
                },
            },
            {
                headerName: '报名提交时间',
                field: 'applySubmitTime',
                width: 15,
                cellStyle: {
                    textAlign: 'center',
                },
                style: {
                    alignment: { vertical: 'bottom', horizontal: 'left' },
                },
            },
            {
                headerName: '申请人账号',
                field: 'applicantUserName',
                width: 15,
                cellStyle: {
                    textAlign: 'center',
                },
                style: {
                    alignment: { vertical: 'bottom', horizontal: 'left' },
                },
            },
            {
                headerName: '申请人姓名',
                field: 'applicantFullName',
                width: 15,
                cellStyle: {
                    textAlign: 'center',
                },
                style: {
                    alignment: { vertical: 'bottom', horizontal: 'left' },
                },
            },
            {
                headerName: '报名时间',
                field: 'applyDate',
                width: 25,
                cellStyle: {
                    textAlign: 'center',
                },
                style: {
                    alignment: { vertical: 'bottom', horizontal: 'left' },
                },
            },
        ]
        if (o['success']) {
            let data = Object.assign([], o['data'])
            data.forEach((val, index) => {
                val['status'] = _getValue('status', val['status'])
                val['jobState'] = _getValue('jobState', val['jobState'])
                val['applyDate'] = val['applyStartTime'] + '~' + val['applyEndTime']
                if(val.mobile !== ''&& val.mobile !== null && val.mobile !== undefined) {
                    val.mobile=val.mobile.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2");
                }
            })
            WizBrowserExport({
                title: '报名申请',
                sheetName: '报名申请',
                columns: columnDefs.filter((_, index) => index),
                rows: data,
                filename: '报名申请.xlsx',
            })
            return true;
        } else {
            wizNotice.error(o['msg'])
            return false;
        }
    }

    _render() {
        let {applyInfo} = this.state
        let params = {}
        if (applyInfo && applyInfo.id) {
             params = { applyName: applyInfo.name, applyId: applyInfo.id}
        }
        let _reduxTemplateCofig = reduxTemplateCofig({
            templateConfig: templateConfig({ look: this.look, onDo: this, params }),
            apiDataFormat: {
                delete: this._handleCMD.bind(this),
                export: this._handleFile,
                batchAudit: this._handleAuditCMD.bind(this),
            },
            params
        })
        return <>
            <WizReduxTemplate {..._reduxTemplateCofig} />
        </>
    }
}

const mapStateToProps = (state, ownProps) => {
    const { } = state;
    return {
    }
};

export default connect(mapStateToProps)(applyVerifyList);
